
import React, { useState, useRef } from "react";

import { supabase } from '../api/supabase';
import { getUtmValues } from '../utils/utm';
import {XIcon} from '@heroicons/react/solid'


const SUBMIT_COOLDOWN_MS = 60 * 1000;
let lastSubmittedAt = 0;

function Modal({setViewModal, viewModal, handleAlert}) {

  const submittingRef = useRef(false);
  const nameRef = useRef();
  const emailRef = useRef();
  const numberRef = useRef();
  const educationRef = useRef();
  const experienceRef = useRef();
  
  const [formAlert, setFormAlert] = useState('');

  const addEmployee = async (e) => {
    e.preventDefault();

    // Block repeat submits (held Enter, double click, bots) while one is in flight.
    if (submittingRef.current) return;

    // Submitted successfully less than a minute ago: don't insert again, just confirm.
    if (Date.now() - lastSubmittedAt < SUBMIT_COOLDOWN_MS) {
      setViewModal(!viewModal);
      handleAlert();
      return;
    }

    const Name = nameRef.current.value;
    const Email = emailRef.current.value;
    const Phone = numberRef.current.value;
    const Education = educationRef.current.value;
    const Experience = experienceRef.current.value;

    if (!supabase) {
      console.error('Supabase is not configured. Add REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY to .env.local');
      setFormAlert('Form is temporarily unavailable. Please try again later.');
      return;
    }

    // Supabase: insert into free_consultation
    // (both "Talk to Career Mentor" and "Talk to our Career Counsellor" buttons land here)
    submittingRef.current = true;
    let error;
    try {
      ({ error } = await supabase.from('free_consultation').insert({
        name: Name,
        email: Email,
        phone: Phone,
        education: Education,
        experience: Experience,
        ...getUtmValues(),
      }));
    } finally {
      submittingRef.current = false;
    }

    if (error) {
      console.error(error);
      return;
    }

    lastSubmittedAt = Date.now();
    setViewModal(!viewModal);
    handleAlert()
  };

  return (
    <div  className="min-w-screen h-screen animated fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 outline-none focus:outline-none bg-no-repeat bg-center bg-cover" id="modal-id">
    <div onClick={()=>setViewModal(!viewModal)} className="absolute h-full w-full bg-black bg-opacity-80 inset-0 -z-10"></div>
    <div className='relative  flex p-3'>
 <div className="relative w-full flex flex-col max-w-[400px] shrink py-2 px-5  rounded-xl shadow-lg  bg-gray-900 ">
  
   {/* <!--content--> */}
   <div className='text-left  text-lg  px-3 pt-10 pb-4 text-gray-300'>Please enter your details to get a call back from <span className='text-xl '> Career Mentor</span> </div>
   <div onClick={()=>setViewModal(!viewModal)} className='absolute right-4 top-3'> <XIcon className='w-7 p-1 text-white hover:text-[#FF0049]'></XIcon> </div>
   <div className="">
<form 
  action="#" 
  onSubmit={addEmployee} 
  className=""
>
  {/* Form body */}
  <div className='p-3 py-6 space-y-5'>
    <div className='space-y-7'>
      
      {/* Name Field */}
      <div className='w-full text-left'>
        <p className='text-sm 2xl:text-base text-gray-100'>Your Name</p>
        <input 
          className='form-control text-[0.95rem] 2xl:text-lg outline-none border-gray-800 bg-transparent border-b-2 w-full text-gray-100'
          title='Please enter your name' 
          placeholder='Your Name' 
          type="text"
          required 
          ref={nameRef}
        />
      </div>

      {/* Email Field */}
      <div className='w-full text-left'>
        <p className='text-sm 2xl:text-base text-gray-100'>Email</p>
        <input 
          className='form-control text-[0.95rem] 2xl:text-lg outline-none border-gray-800 bg-transparent border-b-2 w-full text-gray-100' 
          title='Please enter a valid email address' 
          placeholder='Enter Your Email Address' 
          type="email"
          required 
          ref={emailRef}
        />
      </div>

      {/* Mobile Field */}
      <div className='w-full text-left'>
        <p className='text-sm 2xl:text-base text-gray-100'>Mobile No</p>
        <input 
          className='form-control text-[0.95rem] 2xl:text-lg outline-none border-gray-800 bg-transparent border-b-2 w-full text-gray-100' 
          title='Please enter a 10 digit mobile number' 
          placeholder='Enter Your Mobile No' 
          pattern='[1-9]{1}[0-9]{9}' 
          type="tel"
          required 
          ref={numberRef}
        />
      </div>

      {/* Education Field */}
      <div className='w-full text-left'>
        <p className='text-sm 2xl:text-base text-gray-100'>Education</p>
        <select aria-label="Select Education" 
          className='form-control text-[0.95rem] 2xl:text-lg outline-none border-gray-800 bg-gray-900 border-b-2 w-full text-gray-100 appearance-none'
          required 
          ref={educationRef}
        >
          <option value="" disabled selected>Select Education</option>
          <option value="any_engineers">any_engineers</option>
          <option value="bca/b.sc">bca/b.sc</option>
          <option value="mca/mtech/m.sc/mba">mca/mtech/m.sc/mba</option>
          <option value="diploma">diploma</option>
          <option value="other_degree">other_degree</option>
        </select>
      </div>

      {/* Experience Field */}
      <div className='w-full text-left'>
        <p className='text-sm 2xl:text-base text-gray-100'>Experience</p>
        <select aria-label="Select Experience" 
          className='form-control text-[0.95rem] 2xl:text-lg outline-none border-gray-800 bg-gray-900 border-b-2 w-full text-gray-100 appearance-none'
          required 
          ref={experienceRef}
        >
          <option value="" disabled selected>Select Experience</option>
          <option value="it_working_professional">it_working_professional</option>
          <option value="non-it_working_professional">non-it_working_professional</option>
          <option value="fresher-looking_for_job">fresher-looking_for_job</option>
          <option value="student">student</option>
        </select>
      </div>
    </div>

    {/* Consent */}
    <p className='text-[10px] 2xl:text-[10px] text-gray-100 text-left'>
      I authorise MicroDegree & its representatives to contact me...
    </p>

    {/* Submit Button */}
    <div className="p-3 mt-2 text-center space-x-4 md:block">
      <button 
        type="submit"
        className="mb-2 2xl:text-lg md:mb-0 bg-[#FF0049] rounded-sm px-5 py-2 text-sm shadow-sm font-medium tracking-wider text-white w-full hover:shadow-lg"
      >
        Submit
      </button>
    </div>
  </div>
</form>

   </div>
   </div>
 </div>
</div>
  )
}

export default Modal